// Types are globally available from @/types/chat-sse.d.ts

/**
 * Sets up the request parameters and URL for the SSE stream
 *
 * @param params - The send parameters
 * @param options - Optional hook configuration
 * @returns Object containing search params and aiImportId
 */
export function setupStreamRequest(
  params: SendParams,
  options?: UseChatSSEOptions
): { search: URLSearchParams; aiImportId: string | number | undefined } {
  const { question } = params;
  const aiImportId = params.aiImportId ?? options?.defaultAiImportId;

  const search = new URLSearchParams();
  search.append("question", question);
  if (aiImportId != null) search.append("aiImportId", String(aiImportId));
  if (params.selectedContext != null) search.append("selectedContext", String(params.selectedContext));

  return { search, aiImportId };
}
